module.exports = __webpack_public_path__ + "img/great.943710cd.svg";